import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import FormSearchCriteria from '../../../../library/form/components/FormSearchCriteria';

const ListChoiceSearch = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null);

    // console.log("ListSearch",formObject);

    return (
        <div className='phViewArea'>
            <div className="uiEditableContent">
                <div className="uiRow">
                    <div className="uiSpacer15">
                        <FormSearchCriteria formObject={formObject} enableSearch={false} enableGroups={false} enablefav={false} 
                            action={{ actionId: "refresh", refreshMode:"dep", viewDataReload: 1, actionParam:{ partialupdate: "1"} }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withView(ListChoiceSearch, "listChoiceCriteria", "listChoice")
